import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { Auth0ProviderOptions } from "@auth0/auth0-react/src/auth0-provider";

function Auth0ProviderWithNavigate(props: Auth0ProviderOptions) {
  const {
    domain,
    clientId,
    authorizationParams: { redirect_uri: redirectUri },
    children,
  } = props;

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
      }}
    >
      {children}
    </Auth0Provider>
  );
}

export default Auth0ProviderWithNavigate;
